import { render, staticRenderFns } from "./IconForward.vue?vue&type=template&id=d837f59c&"
import script from "./IconForward.vue?vue&type=script&lang=js&"
export * from "./IconForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports